module.exports = __webpack_public_path__ + "img/ltr-img.b57cc1c0.png";